module.exports = __webpack_public_path__ + "media/images/partner/supporter/not_approved/aldi-1a44ff7405546d2b919a3c0a410b828a.png";